<script setup lang="ts">
import { NuxtLink } from '#components'

const { breadcrumbs } = useNav()
</script>

<template>
  <nav
    v-if="breadcrumbs.length > 0"
    class="text-sm text-icsgray-800 py-3 flex gap-2 items-center dark:text-icsgray-200"
  >
    <NuxtLink
      class="focusable transition-color @hover:text-icsgray-600 @hover:dark:text-icsgray-50"
      to="/"
    >
      Home
    </NuxtLink>
    <template
      v-for="crumb, index in breadcrumbs"
      :key="crumb.to"
    >
      <span>/</span>
      <component
        :is="index === breadcrumbs.length - 1 ? 'span' : NuxtLink"
        :to="crumb.to"
        class="focusable capitalize transition-color @hover:text-icsgray-600 @hover:dark:text-icsgray-50 last:opacity-62 last:pointer-events-none"
      >
        {{ crumb.title }}
      </component>
    </template>
  </nav>
</template>
